import React, { Component } from "react";
import { Row, Col } from "reactstrap";

class SectionTitleContact extends Component {
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col lg={{ size: 8, offset: 2 }}>
          <div className=" ">
            <h1 className="section-title text-center">{this.props.title}</h1>
            <div className="section-title-border mt-3"></div>
            <p className="section-subtitle text-muted text-center pt-4 font-secondary" style={{color: 'back'}}> 
              {this.props.description}
            </p>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default SectionTitleContact;
